﻿export class MyGeneralTimer {
    public static Start(p_func: Function): void {
        if (MyGeneralTimer.timerId == null) {
            MyGeneralTimer.timerId = setInterval(MyGeneralTimer.tick, 100);
        }
        MyGeneralTimer.FUNC = p_func;
    }

    public static Stop() {
        console.log("MyGeneralTimer.Stop().called");
        
        if (MyGeneralTimer.timerId != null) {
            clearInterval(MyGeneralTimer.timerId);
            MyGeneralTimer.timerId = null;
        }
        MyGeneralTimer.FUNC = null;
    }

    public static timerId: number = null;
    public static FUNC: Function = null;

    public static tick(): void {
        //console.log("Tick every 0.1 sec");
        //TIMER_COUNTER += 1;
        //NotifyPlus.RespondToxTimer();
        if (MyGeneralTimer.FUNC != null) {
            MyGeneralTimer.FUNC();
        }
    }
}

